"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractKitProvider = exports.ContextProvider = exports.useContractKitContext = void 0;
var contractkit_1 = require("@celo/contractkit");
var react_1 = __importStar(require("react"));
var connectors_1 = require("./connectors");
var constants_1 = require("./constants");
var contract_kit_reducer_1 = require("./contract-kit-reducer");
var modals_1 = require("./modals");
var use_contract_kit_methods_1 = require("./use-contract-kit-methods");
var helpers_1 = require("./utils/helpers");
var useIsMounted_1 = require("./utils/useIsMounted");
var initialState = {
    connector: new connectors_1.UnauthenticatedConnector(constants_1.Mainnet),
    connectorInitError: null,
    dapp: {
        name: 'Celo dApp',
        description: 'Celo dApp',
        url: 'https://celo.org',
        icon: 'https://celo.org/favicon.ico',
    },
    network: constants_1.Mainnet,
    networks: constants_1.DEFAULT_NETWORKS,
    pendingActionCount: 0,
    address: null,
    connectionCallback: null,
    feeCurrency: contractkit_1.CeloContract.GoldToken,
};
exports.useContractKitContext = (_a = __read(createContractKitContext(), 2), _a[0]), exports.ContextProvider = _a[1];
// This makes it so we don't have to provide defaults for our context
// and also so that if our hooks are used outside of the Provider it
// will throw an error.
function createContractKitContext() {
    var contractKitContext = react_1.default.createContext(undefined);
    var useCtx = function () {
        var c = react_1.default.useContext(contractKitContext);
        if (!c)
            throw new Error('Components using the use-contractkit hook must be a child of a ContractKitProvider');
        return c;
    };
    return [useCtx, contractKitContext.Provider];
}
var ContractKitProvider = function (_a) {
    var _b;
    var children = _a.children, connectModal = _a.connectModal, actionModal = _a.actionModal, dapp = _a.dapp, _c = _a.network, network = _c === void 0 ? constants_1.Mainnet : _c, _d = _a.networks, networks = _d === void 0 ? constants_1.DEFAULT_NETWORKS : _d, _e = _a.feeCurrency, feeCurrency = _e === void 0 ? contractkit_1.CeloContract.GoldToken : _e;
    var isMountedRef = (0, useIsMounted_1.useIsMounted)();
    var previousConfig = (0, react_1.useMemo)(function () { return (0, helpers_1.loadPreviousConfig)(network); }, [network]);
    var _f = __read((0, react_1.useReducer)(contract_kit_reducer_1.contractKitReducer, __assign(__assign(__assign({}, initialState), previousConfig), { network: previousConfig.network || network, networks: networks, feeCurrency: feeCurrency, dapp: __assign(__assign({}, dapp), { icon: (_b = dapp.icon) !== null && _b !== void 0 ? _b : "".concat(dapp.url, "/favicon.ico") }) })), 2), state = _f[0], _dispatch = _f[1];
    var dispatch = (0, react_1.useCallback)(function (type) {
        var payload = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            payload[_i - 1] = arguments[_i];
        }
        if (isMountedRef.current) {
            _dispatch({ type: type, payload: payload[0] });
        }
    }, [isMountedRef]);
    var methods = (0, use_contract_kit_methods_1.useContractKitMethods)(state, dispatch);
    (0, react_1.useEffect)(function () {
        if (connectors_1.CONNECTOR_TYPES[state.connector.type] !== connectors_1.UnauthenticatedConnector) {
            methods.initConnector(state.connector).catch(function () {
                // If the connector fails to initialise on mount then we reset.
                dispatch('destroy');
            });
        }
        /* eslint-disable */
        // We only want this to run on mount so the deps array is empty.
    }, []);
    /* eslint-enable */
    return (react_1.default.createElement(exports.ContextProvider, { value: [state, dispatch, methods] },
        react_1.default.createElement(modals_1.ConnectModal, __assign({}, connectModal)),
        react_1.default.createElement(modals_1.ActionModal, __assign({}, actionModal)),
        children));
};
exports.ContractKitProvider = ContractKitProvider;
//# sourceMappingURL=contract-kit-provider.js.map